import React from 'react';
import { cn } from '../../lib/utils';

const variants = {
  default: 'border-transparent bg-primary text-primary-foreground',
  secondary: 'border-transparent bg-secondary text-secondary-foreground',
  destructive: 'border-transparent bg-destructive text-destructive-foreground',
  outline: 'text-foreground',
  draft: 'border-transparent bg-zinc-500/20 text-zinc-400',
  in_progress: 'border-transparent bg-amber-500/20 text-amber-500',
  review: 'border-transparent bg-blue-500/20 text-blue-500',
  complete: 'border-transparent bg-emerald-500/20 text-emerald-500',
};

const Badge = ({ className, variant = 'default', ...props }) => (
  <div
    className={cn(
      'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
      variants[variant],
      className
    )}
    {...props}
  />
);

export { Badge };
